import { Col, Form, Row } from "antd";
import { HeaderOverview } from "components";
import { PROPERTY_MENUS } from "menus/property";
import { useOverview } from "providers/overview";
import React from "react";
import { useTranslation } from "react-i18next";
import { useGetDashboardSurvey } from "service/dashboard/central/survey";
import { dataMenuCode } from "service/dashboard/central/survey/interface";
import { ErrorDashboard, LoadingDashboard, Wrapper, checkData } from "..";
import ItemSurvey from "./item";
export interface IMenuItem {
  key: string;
  title: string;
  icon?: React.ComponentType;
  code: string;
  slug?: string;
  score: number;
  countResponsibility:number
}

const Survey = () => {
  const { t } = useTranslation();
  const { findDate, property } = useOverview();

  const surveyDate = Form.useWatch("surveyDate");
  const date = findDate(surveyDate);

  const { data, isFetching, isError, error } = useGetDashboardSurvey({
    ...date,
    property,
  });

  const findData = checkData(data);



  const propertyMenu = () => {
    if (!findData) {
      const menus = PROPERTY_MENUS.map((menu) => ({ ...menu, score: 0 }));
      return { menus, avgScore: 0 };
    }

    const filterMenu = PROPERTY_MENUS.filter((e) =>
      dataMenuCode.some((m) => m === e.code)
    );

    const menus = filterMenu.map((menu: any) => {
      const find = findData?.find((entry: any) => entry.code === menu.code);
      return {
        ...menu,
        score: find ? Math.round(find.score) : 0,
        title: t(menu.title, { ns: "menu" }),
        countResponsibility:find?find.countResponsibility :0
      };
    });
    return { menus };
  };

  const { menus  } = propertyMenu() || [];

  return (
    <Wrapper>
      <LoadingDashboard loading={isFetching}>
        <HeaderOverview
          title={t("property.survey", { ns: "menu" })}
          name="surveyDate"
        />
        <Row gutter={[14, 14]} className="h-[400px] overflow-auto">
          {isError ? (
            <ErrorDashboard error={error} />
          ) : (
            menus.map((item) => {
              return (
                <Col key={item.title} sm={24} md={12} lg={8} xl={8} xxl={6}>
                  <ItemSurvey item={item} />
                </Col>
              );
            })
          )}
        </Row>
      </LoadingDashboard>
    </Wrapper>
  );
};

export default Survey;
